const middleware = {}

middleware['payment_enabled'] = require('../middleware/payment_enabled.ts')
middleware['payment_enabled'] = middleware['payment_enabled'].default || middleware['payment_enabled']

export default middleware
